import { render, staticRenderFns } from "./postalCode.vue?vue&type=template&id=af31c1a4&"
import script from "./postalCode.vue?vue&type=script&lang=ts&"
export * from "./postalCode.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports